import { render, staticRenderFns } from "./AgronomyExtracts.vue?vue&type=template&id=393909d0&scoped=true&"
import script from "./AgronomyExtracts.vue?vue&type=script&lang=js&"
export * from "./AgronomyExtracts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "393909d0",
  null
  
)

export default component.exports